module.exports = __webpack_public_path__ + "static/2-659ef899c699a688e03582a5a1bfb9d8.jpg";